import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText,
} from '../../../components/garages-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อศูนย์บริการ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'name',
    sortable: true,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 350,
    margin: '0 50px',
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เบอร์โทรศัพท์
        </HeaderLabel>
      </Div>
    ),
    accessor: 'phoneNumber',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขผู้เสียภาษี
        </HeaderLabel>
      </Div>
    ),
    accessor: 'taxId',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
